import { render, staticRenderFns } from "./GruposTeacher.vue?vue&type=template&id=132a21ea&scoped=true"
import script from "./GruposTeacher.vue?vue&type=script&lang=js"
export * from "./GruposTeacher.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "132a21ea",
  null
  
)

export default component.exports